import { useMemo } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { useGenericSearch } from '@/hooks/useGenericSearch';
import { useRealtimeSubscription } from '@/hooks/useRealtimeSubscription';
import { Statistic } from '@/types';

export const useCustomerIntegrationHealth = () => {
  const query = useGenericSearch({
    query: '#statistic#integration#status#now',
    allTenants: true,
  });

  const debouncedInvalidate = useDebouncedCallback(() => {
    query.invalidate();
  }, 2000);

  useRealtimeSubscription({
    patterns: [{ pattern: '#statistic#', matchType: 'prefix' }],
    user: false,
    onUpdate: debouncedInvalidate,
  });

  const dataMap = useMemo(() => {
    const accounts: Statistic[] = query.data?.statistics || [];

    return new Map(
      accounts.map(item => {
        const counts = (item.data?.counts || {}) as Record<string, number>;
        const totalIntegrations = Object.values(counts).reduce(
          (acc, curr) => (acc as number) + (curr as number),
          0
        );
        return [
          item.username,
          {
            healthyIntegrations: counts?.['JP'] || 0,
            totalIntegrations,
          },
        ];
      })
    );
  }, [query.data]);

  return {
    ...query,
    dataMap,
  };
};
